module.exports = __webpack_public_path__ + "img/1.376fdd6d.png";